import { Spinner } from '@cian/ui-kit';
import cx from 'clsx';
import * as React from 'react';

import * as styles from './styles.css';

interface ILoadingProps {
  overlap?: boolean;
  height?: number;
  size?: number;
}

export const Loading: React.FC<ILoadingProps> = ({ overlap, height, size = 24 }) => {
  return (
    <div
      className={cx(styles['loading'], overlap && styles['overlap'])}
      style={{ height }}
      data-testid="offers_history_loading"
    >
      <Spinner size={size} />
    </div>
  );
};
